import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LandingPage.css';
import './PoliticaPrivacidade.css';
import './ManualUso.css';
import logo from './assets/logo.png';

const PoliticaPrivacidade = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="landing-page" style={{ background: '#fff', minHeight: '100vh', padding: '0' }}>
            
            {/* CABEÇALHO/BANNER */}
            <div className="manual-hero-banner">
                <div className="manual-hero-overlay">
                    <button
                        className="back-home-button-modern"
                        onClick={() => navigate('/')}
                    >
                        <div className="back-button-circle">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#00AEEF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <span className="back-button-text">Voltar para a Home</span>
                    </button>
                    
                    <div className="manual-hero-content">
                        <h1 className="manual-hero-title">Política de Privacidade</h1>
                        <p className="manual-hero-subtitle">Transparência e segurança no tratamento de seus dados</p>
                    </div>
                </div>
            </div>

            <div style={{ maxWidth: '800px', margin: '4rem auto 0 auto', padding: '0 2rem', fontFamily: 'Poppins, sans-serif', color: '#333', lineHeight: '1.6', textAlign: 'left' }}>
                
                <p style={{ fontWeight: '500', marginBottom: '2rem', textAlign: 'center' }}>Última atualização: 28 de abril de 2026</p>

                <p style={{ textAlign: 'left' }}>
                    A <strong>VECTOR TRACKER SOLUÇÕES DIGITAIS INOVA SIMPLES (I.S.)</strong>, inscrita no CNPJ sob o nº 64.785.501/0001-03, doravante denominada "Vector Tracker", estabelece esta política para garantir a transparência no tratamento de dados voltados à vigilância entomológica e epidemiológica, com foco inicial no inseto triatomíneo (barbeiro), transmissor da Doença de Chagas, e expansão para o controle de outras arboviroses e zoonoses.
                </p>

                <section style={{ marginTop: '2rem', textAlign: 'left' }}>
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1a1a1a', textAlign: 'left' }}>1. Coleta de Dados e Identificação de Vetores</h2>
                    <p style={{ textAlign: 'left' }}>
                        O aplicativo coleta informações para auxiliar na identificação de vetores e no mapeamento de riscos à saúde pública. Os registros são tratados como dados de saúde pública e prevenção, conforme as categorias de serviços de saúde declaradas na Google Play Store.
                    </p>
                    <p style={{ textAlign: 'left', marginTop: '1rem' }}>Os dados variam conforme o perfil:</p>
                    <ul style={{ paddingLeft: '1.2rem', textAlign: 'left' }}>
                        <li style={{ marginBottom: '1rem' }}>
                            <strong>Comunidade (Cidadão):</strong> O usuário pode realizar a denúncia da comunidade de forma identificada (via login) ou de forma anônima. Em ambos os casos, são coletados: foto da denúncia (obrigatória), descrição do local, localização GPS automática e endereço detalhado. <strong>Nota: Embora não sejam coletados prontuários ou histórico clínico individual, os registros entomológicos e de localização são coletados para fins de prevenção de doenças.</strong>
                        </li>
                        <li>
                            <strong>Agente de Combate às Endemias (ACE):</strong> Coleta de dados técnicos de campo (características da habitação), registros de captura de triatomíneos, informações detalhadas de borrifação (tipo de inseticida, cargas utilizadas e rendimento do trabalho), dados de infraestrutura urbana/rural das localidades (saneamento, energia, coleta de lixo), presença de animais domésticos e sinantrópicos (cachorros, gatos, roedores), e indicadores de risco ou ocorrência de doenças como Malária, Dengue, Leishmaniose, entre outras. Também são coletadas coordenadas GPS precisas e fotografias comprobatórias.
                        </li>
                    </ul>
                </section>

                <section style={{ marginTop: '2rem', textAlign: 'left' }}>
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1a1a1a', textAlign: 'left' }}>2. Fluxo de Dados e Participação Municipal</h2>
                    <p style={{ textAlign: 'left' }}>O destino das informações fornecidas pela comunidade depende da adesão do poder público ao projeto:</p>
                    <ul style={{ paddingLeft: '1.2rem', textAlign: 'left' }}>
                        <li style={{ marginBottom: '1rem' }}>
                            <strong>Municípios Participantes:</strong> Caso o município onde a denúncia da comunidade foi registrada faça parte do projeto Vector Tracker, os dados serão encaminhados diretamente ao Agente de Combate às Endemias (ACE) local para validação e visita de campo.
                        </li>
                        <li>
                            <strong>Municípios Não Participantes:</strong> Caso o município não possua adesão ativa, as denúncias fornecidas pela comunidade não gerarão notificações de visita imediata, servindo exclusivamente para compor nosso banco de dados de pesquisa.
                        </li>
                    </ul>
                </section>

                <section style={{ marginTop: '2rem', textAlign: 'left' }}>
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1a1a1a', textAlign: 'left' }}>3. Finalidade do Tratamento (Saúde Pública e Ciência)</h2>
                    <p style={{ textAlign: 'left' }}>
                        O tratamento dos dados visa:
                    </p>
                    <ul style={{ paddingLeft: '1.2rem', textAlign: 'left' }}>
                        <li style={{ marginBottom: '0.5rem' }}>
                            <strong>Vigilância em Saúde:</strong> Auxiliar órgãos públicos no controle de arboviroses e zoonoses através do mapeamento de focos.
                        </li>
                        <li>
                            <strong>Pesquisa Científica:</strong> Como iniciativa de base tecnológica e científica (projeto originado no programa StartUFPI), os dados coletados podem ser utilizados para estudos entomológicos e análise de dispersão vetorial. Para fins científicos, os dados são <strong>tratados de forma agregada ou anonimizada.</strong>
                        </li>
                    </ul>
                </section>

                <section style={{ marginTop: '2rem', textAlign: 'left' }}>
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1a1a1a', textAlign: 'left' }}>4. Armazenamento e Segurança</h2>
                    <ul style={{ paddingLeft: '1.2rem', textAlign: 'left' }}>
                        <li style={{ marginBottom: '1rem' }}>
                            <strong>Infraestrutura:</strong> Os dados são processados e armazenados via Supabase, com criptografia e acesso restrito por meio de Row Level Security (RLS).
                        </li>
                        <li style={{ marginBottom: '1rem' }}>
                            <strong>Mapas:</strong> A geolocalização utiliza a tecnologia do Google Maps para converter coordenadas em pontos de análise entomológica.
                        </li>
                        <li>
                            <strong>Sigilo e Acesso:</strong> Não comercializamos dados pessoais para publicidade. O acesso aos dados detalhados para fins de vigilância é restrito aos gestores dos municípios que possuem contrato de adesão ativa com a plataforma.
                        </li>
                    </ul>
                </section>

                <section style={{ marginTop: '2rem', marginBottom: '4rem', textAlign: 'left' }}>
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1a1a1a', textAlign: 'left' }}>5. Direitos do Usuário (LGPD) e Retenção de Dados</h2>
                    <p style={{ textAlign: 'left', marginBottom: '1rem' }}>
                        O usuário tem o direito de acessar seus dados e solicitar a exclusão de sua conta através do aplicativo ou pelo e-mail <strong>contato@vectortrackers.com</strong>. Em relação às denúncias realizadas pelo perfil Comunidade, aplicam-se as seguintes regras:
                    </p>
                    <ul style={{ paddingLeft: '1.2rem', textAlign: 'left' }}>
                        <li style={{ marginBottom: '1rem' }}>
                            <strong>Denúncias não atendidas:</strong> Podem ser excluídas integralmente pelo usuário a qualquer momento, desde que ainda não tenham sido validadas ou visitadas por um agente.
                        </li>
                        <li style={{ marginBottom: '1rem' }}>
                            <strong>Denúncias atendidas:</strong> Caso a denúncia já tenha gerado uma visita ou registro em campo, ela passa a compor o mapa de vigilância entomológica, sendo considerada um dado de interesse público. Se o usuário solicitar a exclusão da conta, seus dados pessoais de identificação serão anonimizados, mas as informações da ocorrência (como o registro do vetor e a localização) serão mantidas no banco de dados para fins estatísticos e de saúde pública.
                        </li>
                        <li>
                            <strong>Registros técnicos:</strong> Registros realizados diretamente pelos Agentes de Combate às Endemias (ACE), incluindo dados de RG-03 e Borrifação, seguem os protocolos de retenção e arquivamento da administração pública local, garantindo a integridade dos dados históricos da vigilância em saúde, não sendo passíveis de exclusão manual pelo profissional.
                        </li>
                    </ul>
                </section>
            </div>

            <footer className="landing-footer">
                <div className="footer-content">
                    <div className="footer-brand">
                        <img src={logo} alt="Vector Tracker Logo" className="footer-logo" />
                        <span>Vector Tracker</span>
                    </div>
                    <div className="footer-links">
                        <h4>Políticas</h4>
                        <Link to="/politica-de-privacidade">Política de Privacidade</Link>
                        <Link to="/manual-de-uso">Manual de Uso</Link>
                    </div>
                </div>
                <div className="footer-separator"></div>
                <div className="footer-bottom">
                    <p>VECTOR TRACKER SOLUCOES DIGITAIS INOVA SIMPLES (I.S.) | 64.785.501/0001-03</p>
                    <p>© 2026 Vector Tracker</p>
                </div>
            </footer>
        </div>
    );
};

export default PoliticaPrivacidade;
